export default function Pencil({width, height}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1603_169606)">
        <path
          d="M12.2291 2.82166L2.86328 12.1875L7.81863 17.1428L17.1845 7.777L12.2291 2.82166Z"
          fill="#CEB2E9"
        />
        <path
          d="M19.7007 3.9858L16.0425 0.275749C15.6793 -0.0874723 15.1085 -0.0874723 14.7712 0.249805C14.7712 0.249805 14.7712 0.249805 14.7453 0.275749L13.1367 1.8843L18.0921 6.86563L19.7007 5.25708C20.0639 4.89386 20.0639 4.32308 19.7007 3.9858Z"
          fill="#CEB2E9"
        />
        <path
          d="M2.1386 13.2734L0.088987 18.7737C-0.0926239 19.2407 0.140876 19.7595 0.607875 19.9412C0.815431 20.019 1.04893 20.019 1.25649 19.9412L6.7567 17.8656L2.1386 13.2734Z"
          fill="#CEB2E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_1603_169606">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
